// extracted by mini-css-extract-plugin
export var arrow = "_jj-1";
export var content = "_jj-0";
export var highlighted = "_jj-2";